import { inject } from "@angular/core";
import { CanDeactivateFn, UrlTree } from "@angular/router";
import { alert } from "devextreme/ui/dialog";
import { Observable } from "rxjs";
import { SignalService } from "../services/loader.service";

export type CanDeactivateType =
  | Observable<boolean | UrlTree>
  | Promise<boolean | UrlTree>
  | boolean
  | UrlTree;

export interface CanComponentDeactivate {
  canDeactivate: () => CanDeactivateType;
}

export const editingProposalPageGuard: CanDeactivateFn<any> = (
  component: any,
) => {
  const hasBeenEdited = inject(SignalService).hasBeenEdited();
  if (hasBeenEdited) {
    alert(
      "Make sure to save your progress by pressing 'Save' button",
      "Warning",
    );
  }
  return !hasBeenEdited;
};

export const canDeactivateGuard: CanDeactivateFn<CanComponentDeactivate> = (
  component: CanComponentDeactivate,
) => {
  return component.canDeactivate ? component.canDeactivate() : true;
};
